"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Subject_1 = require("rxjs/internal/Subject");
var react_1 = require("react");
var operators_1 = require("rxjs/operators");
var use_rx_1 = require("./use-rx");
exports.DEBOUNCE = 500;
/**
 * `useRxDebounce`
 *
 * Applies debounce to a given observable function.
 * Can be used in Autosuggest.
 *
 * @param func$
 * @param next
 */
function useRxDebounce(func$, next, debounce) {
    if (debounce === void 0) { debounce = exports.DEBOUNCE; }
    var input$ = react_1.useMemo(function () { return new Subject_1.Subject(); }, [func$]);
    var output$ = react_1.useMemo(function () {
        return input$.pipe(operators_1.debounceTime(debounce), operators_1.switchMap(function (input) { return func$(input); }));
    }, [input$]);
    var _a = react_1.useState(), output = _a[0], setOutput = _a[1];
    use_rx_1.useRx(output$, {
        next: function (val) {
            setOutput(val);
            // Optionally invoke a callback with a given value.
            if (next) {
                next(val);
            }
        }
    });
    return [output, input$.next.bind(input$)];
}
exports.useRxDebounce = useRxDebounce;
//# sourceMappingURL=use-rx-debounce.js.map